import { IconClient } from "../../assets/svgs-index";
import { CommonLabels } from "../../assets/labels/labels";
import PoweredBy from "../../components/PoweredBy/PoweredBy";

const IntroSection = () => {
  return (
    <div className="intro-container">
      <div className="logo-container">
        <img src={IconClient} alt="iconClient" />
      </div>
      <div className="title-container mt-2">
        <h3 className="title-text">{CommonLabels.welcome.title}</h3>
      </div>
      <div className="message-container mt-2">
        <h4 className="message-text">{CommonLabels.welcome.message}</h4>
      </div>
      <PoweredBy styleClass="mt-2 pt-1" />
    </div>
  );
};
export default IntroSection;
